import {
  QUESTION_ANSWER_BLOCK_ELEMENT_TYPE,
  QUESTION_ANSWER_BLOCK_COMPONENT_NAME,
} from 'components/modules/custom-pages/constants/types';

import { DEFAULT_QUESTION_ANSWER_BLOCK_CLASS_NAME } from './constants';
import { createFishermanComponent, getComponentId } from '../utils/components';
import {
  createFinalClassName,
  extractComponentBaseProps,
  getCollectionPropValue,
  createProp,
  createComponentBaseProps,
} from '../utils/props';
import { getQueryPathValue } from '../utils/queries';

export function createQuestionAnswerBlockElement(data = {}) {
  const { id, style, className, questionGroup } = data;

  const finalClassName = createFinalClassName(className, DEFAULT_QUESTION_ANSWER_BLOCK_CLASS_NAME);

  const recipeSnippet = createFishermanComponent(QUESTION_ANSWER_BLOCK_COMPONENT_NAME, id, [
    ...createComponentBaseProps(finalClassName, style),
    createProp('questions', {
      type: 'QUERY',
      value: {
        query: {
          allFishermanBusinessQuestion: {
            __args: {
              filter: {
                groups: {
                  elemMatch: {
                    _id: {
                      eq: questionGroup,
                    },
                  },
                },
              },
              sort: {
                order: {
                  __enum: true,
                  enumValue: 'ASC',
                },
                fields: {
                  __enum: true,
                  enumValue: 'groups___orderInGroup',
                },
              },
            },
            nodes: {
              _id: true,
              text: true,
              mainAnswer: {
                text: true,
              },
            },
          },
        },
        payload: 'allFishermanBusinessQuestion.nodes',
      },
    }),
  ]);

  return recipeSnippet;
}

export function createQuestionAnswerBlockState(recipeSnippet = {}) {
  const { props } = recipeSnippet || {};

  const type = QUESTION_ANSWER_BLOCK_ELEMENT_TYPE;
  const { className, style } = extractComponentBaseProps(recipeSnippet);

  const id = getComponentId(recipeSnippet);

  const querySnippet = getCollectionPropValue(props, 'questions');

  const questionGroup = getQueryPathValue(
    querySnippet,
    'allFishermanBusinessQuestion',
    '__args.filter.groups.elemMatch._id.eq',
  );

  return {
    id,
    className,
    style,
    type,
    questionGroup,
    componentName: QUESTION_ANSWER_BLOCK_COMPONENT_NAME,
  };
}

export function createQuestionAnswerBlockTemplateState(data = {}) {
  const { questionGroup, ...restQuestionAnswerBlock } = data;

  return {
    ...restQuestionAnswerBlock,
  };
}
